<template>
  <a-layout id="components-layout-demo-top-side-2">
    <a-layout>
      <a-layout-sider width="256" style="background: #fff">
        <div class="dashboard"><span>供应链主营系统</span></div>
        <!-- 菜单 -->
        <a-menu
          mode="inline"
          :defaultSelectedKeys="defaultSelectedKeys"
          @click="handleClick"
					:defaultOpenKeys='["account-no","category","product","order","account"]'
          v-model="selectedKeys"
        >
          <a-sub-menu
            v-for="item in menu"
            v-show="item.meta&&!(item.meta.unShow)"
            :key="item.name"
          >
            <subSpan slot="title"
              v-if="item.meta&&item.meta.icon"
              :iconClass="item.meta.icon"
              :title="item.meta.title"
              :selectedKeys="selectedKeys[0]"
              :routeItem="item.children"
            />
            <a-menu-item
              :key="c.name"
              v-for="c in item.children"
              v-if="c.meta&&!c.meta.noMenu"
            >
              {{c.meta&&c.meta.title}}
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-layout-sider>
      <a-layout  class="right-container">
        <!-- 消息提醒，退出 -->
        <a-layout-header style="">
          <div style="text-align: right; position: relative;" ref='home'>
            <span  class="mes-tip">
              <a-badge dot :count="messageCount" style="margin-right:24px" @click="toMessage">
                <a-icon type="bell" :style="{ fontSize: '16px' }" />
              </a-badge>
            </span>
            <a-popover  trigger="click" placement="bottomLeft"   :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body;
              }"
            >
              <div slot="content" class="my-account">
                <div class="account">
                  <span class="account-alias">{{alias}}</span><br>
                  <span class="account-tel">{{account}}</span>
                </div>
                <div style="padding:9px 10px;padding-bottom:17px"><span style="cursor: pointer;" @click="logout"><img src="../../assets/img/logout.png" alt="">&nbsp退出登录</span></div>
              </div>
              <img src="@/assets/img/avatar.png" alt="" style="cursor: pointer;">
            </a-popover>
          </div>
        </a-layout-header >
        <breadcrumb :routeData="routeData"></breadcrumb>
        <a-layout-content >
          <router-view/>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script>
import {mapState} from "vuex";
import subSpan from "@/components/sub-span";
import breadcrumb from "@/components/breadcrumb";
export default {
  name:"home",
  components:{subSpan,breadcrumb},
  data() {
    return {
      orderType:"",
      menu:[],
      visible:false,
      account:'',
      alias:'',
      defaultOpenKeys:[],
      defaultSelectedKeys:[],
      selectedKeys:[]
    };
  },
   computed: {
     ...mapState(['user_name','messageCount']),
    title(){
      return this.$route.query&&this.$route.query.title
    },
    message(){
      if (this.$route.name == 'message') {
        return 0
      }else{
        return localStorage.getItem("messageCount")
      }
    },
    routeData() {
      let route = this.$route.matched
      let toName = this.$route.name;
      let orderType = this.orderType;
      if (toName === "order-detail"||toName === "order-channel"||toName === "order-advance"||toName === "order-after") {
        if (orderType == "1") {
          return [
            {meta:{title:'首页'} },
            {meta:{title:'订单'} },
            {meta:{title:'订单管理'},name:"order-manage" },
            {meta:{title:'订单详情'} },
          ]
        } else if (orderType == "2"){
          return [//首页/账户/渠道商资金账户/冻结资金
            {meta:{title:'首页'} },
            {meta:{title:'账户'},name:"account"},
            {meta:{title:'渠道商资金账户'},name:"channel-account" },
            {meta:{title:'冻结资金'},name:"channel-capital"},
            {meta:{title:'订单详情'} },
          ] 
        } else if (orderType == "3"){
          return [//首页/账户/渠道商资金账户/冻结资金
            {meta:{title:'首页'} },
            {meta:{title:'账户'},name:"account"},
            {meta:{title:'渠道商资金账户'},name:"channel-account" },
            {meta:{title:'已用资金'},name:"channel-capital"},
            {meta:{title:'订单详情'} },
          ] 
        } else if (orderType == "4"){
          return [//首页/账户/渠道商资金账户/冻结资金
            {meta:{title:'首页'} },
            {meta:{title:'账户'},name:"account"},
            {meta:{title:'渠道商资金账户'},name:"channel-account" },
            {meta:{title:'授信金额'},name:"channel-capital"},
            {meta:{title:'订单详情'} },
          ] 
        } else if (orderType == "5") {
          return [
            {meta:{title:'首页'} },
            {meta:{title:'账户'} ,name:"account"},
            {meta:{title:'供应商资金账户'},name:'supplier-account' },
            {meta:{title:'冻结资金'} ,name:'supplier-advance'},
            {meta:{title:'订单详情'} },
          ]
        } else if (orderType == "6") {
          return [
            {meta:{title:'首页'} },
            {meta:{title:'账户'} ,name:"account"},
            {meta:{title:'供应商资金账户'},name:'supplier-account' },
            {meta:{title:'已用资金'} ,name:'supplier-advance'},
            {meta:{title:'订单详情'} },
          ]
        } else if (orderType == "7") {
          return [
            {meta:{title:'首页'} },
            {meta:{title:'账户'} ,name:"account"},
            {meta:{title:'供应商资金账户'},name:'supplier-account' },
            {meta:{title:'订单结算'} ,name:'supplier-account'},
            {meta:{title:'结算单详情'} ,name:'settlement-detail'},
            {meta:{title:'订单详情'} },
          ]
        }
      } 
      if (this.$route.name === "settlement-detail") {
        return [
          {meta:{title:'首页'} },
          {meta:{title:'账户'} },
          {meta:{title:'供应商资金账户'} ,name:'supplier-account'},
          {meta:{title:'订单结算'} },
          {meta:{title:'结算单详情'} },
        ]
      }
      else if (this.$route.name === "sub-category") {
        return [
          {meta:{title:'首页'} },
           {meta:{title:'类目'},name:"category" },
            {meta:{title:'类目管理'},name:'category-manage' },
              {meta:{title:this.$route.query.btitle} },
        ]
      }
       return route;
    }
  },
  watch: {
    $route:{
      handler(val,oldval){
        let orderType = this.$route.query.orderType;
        if (orderType&&orderType!="") {
          this.orderType = this.$route.query.orderType||'';
        }
				if(this.$route.name != "message"){
					this.selectedKeys = [this.routeData[2].name];
        }
      },
      // 深度观察监听
      deep: true
    },
    user_name(newVal) {
      this.alias = newVal;
    }
  },
  created(){
    let orderType = this.$route.query.orderType;
    if (orderType&&orderType!="") {
      this.orderType = orderType;
    }
    if (this.$route.name != "message") {
			this.selectedKeys = [this.routeData[2].name];
    }
    this.account = localStorage.getItem("account")||'';
    this.alias = this.user_name||'';
    this.menu=this.$router.options.routes[0].children;
  },
  methods:{
    logout(){
      this.$http.post('signout').then(res=>{
        this.$router.push({name:'login'})
        // console.log('登出成功');
      })
    },
    toMessage(){
      if (this.$route.name == 'message') {
        return
      }
      this.$router.push({name:'message'})
    },
    handleClick(e) {
      if (e.key&&this.$route.name == e.key) {
        return
      }
      this.$router.push({name:e.key})
    },
  }
};
</script>

<style lang="less" scoped>
.mes-tip{
  vertical-align: middle;
  cursor: pointer;
}
.item-title {
  margin-top: 12px;
  color: rgba(56, 56, 56, 1);
  font-size: 18px;
  line-height: 27px;
  text-align: left;
  font-weight: bold;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item{
  margin-left: 26px;
  margin-right: 26px;
  padding-left: 26px!important;
  overflow: hidden;
  border-radius:4px;
}
.ant-menu-inline .ant-menu-item, .ant-menu-inline .ant-menu-submenu-title {
  width: 212px;
}
.dashboard{
  height:48px;
  line-height:48px; 
  padding-left:24px;
  color:#000000;
  font-size: 16px;
  font-weight:500;
}
.ant-menu-inline .ant-menu-item::after {
    border-right: 0;
}
.ant-layout-header {
    height: 48px; 
    line-height: 48px; 
    background:#FFFFFF;
}
#components-layout-demo-top-side-2{
	height: 100%; 
  ::-webkit-scrollbar{
    width:0;
  }
}
.ant-layout-sider{
	overflow-y: auto;
  border-right: 1px solid rgba(0,0,0,0.06);
}
.right-container{
  min-width: 768px;
}
/deep/.ant-layout-content {
    min-height: auto;
}

.account{
  padding-bottom: 17px;
  border-bottom: 1px solid #e8e8e8;
  span{
    padding-bottom:4px;
  }
}
/deep/.ant-popover-arrow{
  display: none!important;
}
/deep/.ant-popover-inner-content{
  width: 216px;
  height: 130px;
}
/deep/.ant-popover-inner-content{
  padding: 20px 16px;
}

/deep/.ant-layout-header{
  padding-right:24px; 
}
.my-account{
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  line-height:24px;
  .account-alias{
    font-size:16px;
    font-weight:400;
    color:rgba(0,0,0,0.8);
    line-height:24px;
  }
  .account-tel{
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,0.65);
    line-height:22px;
  }
}
</style>
